import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/ModelsInternalResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/machinelearning/configuration/modellisting`;
	}
	listModelsByProjectId(e, t = []) {
		return this.api.get(this.buildPath(`${n.baseUrl}/project`, {
			projectId: e,
			engineIds: t
		}));
	}
};
//#endregion
export { n as ModelsInternalResource };

//# sourceMappingURL=ModelsInternalResource.js.map